export default __webpack_public_path__ + "static/media/Chhatt_social_f.8ba9b5ff.wav";